import { render, staticRenderFns } from "./FormCadastrarPerfil.vue?vue&type=template&id=74fff8f6&scoped=true&"
import script from "./FormCadastrarPerfil.vue?vue&type=script&lang=js&"
export * from "./FormCadastrarPerfil.vue?vue&type=script&lang=js&"
import style0 from "./FormCadastrarPerfil.vue?vue&type=style&index=0&id=74fff8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fff8f6",
  null
  
)

export default component.exports